var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7563 18.1462H5.45547C4.63281 18.1462 4 18.8125 4 19.6C4 20.4481 4.63281 21.0539 5.45547 21.0539H33.7563C34.5789 21.0539 35.275 20.4481 35.275 19.6C35.275 18.8125 34.5789 18.1462 33.7563 18.1462ZM33.7563 8.45386H5.45547C4.63281 8.45386 4 9.1202 4 9.9077C4 10.6346 4.63281 11.3615 5.45547 11.3615H33.7563C34.5789 11.3615 35.275 10.7558 35.275 9.96828C35.275 9.24136 34.5789 8.45386 33.7563 8.45386ZM33.7563 27.8385H5.45547C4.63281 27.8385 4 28.5048 4 29.2923C4 30.1404 4.63281 30.7462 5.45547 30.7462H33.7563C34.5789 30.7462 35.275 30.1404 35.275 29.2923C35.275 28.5048 34.5789 27.8385 33.7563 27.8385Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.8919dfab2e16cd5d9fcb1dbdee339f7b.svg";
export { ForwardRef as ReactComponent };